import React from 'react'

export default function LogoPrefete() {
    return (
        <div className="align-center text-center">
            <img src="/assets/images/prefete_de_la_lozere.png" className="w-100" alt="SIAO 48"/>
        </div>
    )}